"use client";

import { useState } from "react";
import { Hero } from "../Hero";
import { Container } from "../Container";
import { GallerySidebar } from "../GallerySidebar";
import styles from "./GalleryPage.module.css";
import { TemplateCard } from "../TemplateCard";
import { Text } from "@zapier/design-system";
import { EmptyState } from "../EmptyState";
import { InfiniteScroll, LoadMoreFn } from "../InfiniteScroll";
import { Category } from "src/server/zsl/templates/types";
import { type Template } from "@zapier/templates";

type TemplatesProps = {
  title: string;
  description: string;
  initialTemplates: Template[];
  navigationCategories: Category[];
  navigationApps: {
    name: string;
    slug: string;
  }[];
  gridTitle: string;
  templatesTotalCount: number;
  onLoadMore: any;
};

export function GalleryPage({
  title,
  description,
  navigationCategories,
  navigationApps,
  initialTemplates,
  gridTitle,
  templatesTotalCount,
  onLoadMore,
}: TemplatesProps) {
  const [templates, setTemplates] = useState<Template[]>(initialTemplates);

  const handleLoadMore: LoadMoreFn = async ({ skip }) => {
    const newTemplates = await onLoadMore(skip);
    setTemplates((prev) => [...prev, ...newTemplates]);
  };

  return (
    <>
      <Hero crumbs={[]} description={description} title={title} titleTag="h1" />
      <Container className={styles.wrapper}>
        <GallerySidebar
          className={styles.styledSidebar}
          categories={navigationCategories}
          apps={navigationApps}
        />
        <div className={styles.main}>
          <div className={styles.gridWrapper}>
            <div className={styles.gridTitle}>
              <Text type="PageHeader" tag="h3">
                {gridTitle}
              </Text>
            </div>
            <div className={styles.cardsWrapper}>
              {templates.length === 0 ? (
                <EmptyState />
              ) : (
                <InfiniteScroll
                  skip={templates.length}
                  total={templatesTotalCount}
                  onLoadMore={handleLoadMore}
                >
                  {templates.map((template) => (
                    <TemplateCard key={template.name} template={template} />
                  ))}
                </InfiniteScroll>
              )}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
